const dupa = [
  {
    0: "PVC Doors and Frames",
    Quantity: 1,
    Labor: [
      {
        Description: "Carpenter",
        No_Of_Person: "1",
        Unit: "3",
        Rate: "78",
        Amount: 236,
      },
      {
        Description: "Laborer",
        No_Of_Person: "2",
        Unit: "3",
        Rate: "60",
        Amount: 364,
      },
    ],
    Equipment: [
      {
        Description: "",
        No_of_Units: "",
        No_Of_Hours: "",
        Rate: "",
        Amount: 0,
      },
    ],
    Materials: [
      {
        Description: "0.60M X 2.10M PVC TYPE DOOR",
        Unit: "set",
        Quantity: "1",
        Unit_Cost: "1800",
        Amount: 1800,
      },
    ],
  },
  {
    0: "Structural Steel",
    Quantity: 2,
    Labor: [
      {
        Description: "Welder",
        No_Of_Person: "3",
        Unit: "121",
        Rate: "78",
        Amount: 28593,
      },
      {
        Description: "Laborer",
        No_Of_Person: "5",
        Unit: "121",
        Rate: "60",
        Amount: 36759,
      },
    ],
    Equipment: [
      {
        Description: "Welding Machine",
        No_of_Units: "1",
        No_Of_Hours: "121",
        Rate: "391",
        Amount: 47311,
      },
    ],
    Materials: [
      {
        Description: "Roof Framing",
        Unit: "",
        Quantity: "",
        Unit_Cost: "",
        Amount: 0,
      },
      {
        Description: "150mm x50mm x2mm thk C purlins",
        Unit: "kgs",
        Quantity: "707",
        Unit_Cost: "54",
        Amount: 38215,
      },
      {
        Description: "16mm dia DRB Anchoraze",
        Unit: "kgs",
        Quantity: "132",
        Unit_Cost: "42",
        Amount: 5568,
      },
    ],
  },
];

export default dupa;
